export function formatCurrency(value) {
  const numericValue = Math.round(Number(value));
  return `$${numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
}


  export function dateType(typeObligation) {
    return typeObligation === 'Credito' ? 'Fecha límite de pago' : 'Fecha próxima factura'
  }


export function maskString(str) {
  if (typeof str !== 'string' || str.length <= 4) {
      return str;
  }

  const visiblePart = str.slice(-4); // Los últimos 4 caracteres
  const maskedPart = '*'.repeat(str.length - 4); // Enmascarar el resto

  return maskedPart + visiblePart;
}
